import React, { useState, useEffect } from "react";
import _ from "underscore";
import { Row, Col, Card, Alert } from "react-bootstrap";
import Sidebar from "../components/SidebarRegistration";
import ErrorMdl from "../components/errorMdl";
import { useAuth } from "./../context/auth";
// import { updateTokens } from "./../context/checkTokens";
import { getQueryStringValue } from "../components/search/queryString";

const axios = require("axios");
const store = require("store");

const UpdateTokenRegistration = (props) => {
  const { authTokens, setAuthTokens } = useAuth();

  const [hasError, setErrors] = useState(true);
  const [errorshow, setErrorShow] = useState(false);
  const [showSuccessmessage, setSuccessmessage] = useState("");

  async function sendUpdate() {
    axios
      .get(
        !_.isUndefined(process.env.REACT_APP_API_URL)
          ? process.env.REACT_APP_API_URL + "/Auth/validateEmail"
          : "/Auth/validateEmail",
        {
          params: { key: getQueryStringValue("_t") },
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res) {
          if (res) {
            if (
              !_.isUndefined(res.status) &&
              res.status === 200 &&
              res.data.status
            ) {
              //Update existing emailVerification
              if (!_.isUndefined(store.get("tokens"))) {
                let existingTokens =
                  !_.isNull(store.get("tokens")) && store.get("tokens") !== ""
                    ? JSON.parse(store.get("tokens"))
                    : null;
                if (existingTokens) {
                  existingTokens["emailVerified"] = 1;
                  setAuthTokens(existingTokens);
                }
              }
              setSuccessmessage("Thanks for verifying your email");
              if (res?.data?.user == 1)
                window.location.href = "/Profile?emailVerified=1";
              else {
                setTimeout(() => {
                  window.location.href = "/Home";
                }, 4000); // 2 seconds
              }
            } else {
              //todo setError;
              setErrors({
                message:
                  "The email verification link you used has expired. For security reasons, verification links are only valid for a limited time.",
              });
              setErrorShow(true);
            }
          } else {
            // const error = new Error(res.error);
            setSuccessmessage("");
            setErrors({
              message:
                "The email verification link you used has expired. For security reasons, verification links are only valid for a limited time.",
            });
            setErrorShow(true);
          }
        } else {
          // const error = new Error(res.error);
          setErrors({
            message:
              "The email verification link you used has expired. For security reasons, verification links are only valid for a limited time.",
          });
          setErrorShow(true);
        }
        //callback for the response
      })
      .catch((error) => {
        setErrors({ message: "Invalid Verification Link" });
        setErrorShow(true);
      });
  }
  useEffect(() => {
    sendUpdate();
  }, []);
  return (
    <main role="main" className="main mt-2 container-fluid">
      <ErrorMdl error={hasError} setErrorShow={setErrorShow} show={errorshow} />

      <Row></Row>
      <Row>
        <Col md="3">{/* <Sidebar {...props} /> */}</Col>
        <Col md="6">
          <Row>
            <Col>
              {showSuccessmessage && (
                <Card variant="info">
                  <Card.Body>
                    <Card.Header>
                      <h2>Email Verification</h2>
                    </Card.Header>
                    <br></br>
                    <Alert variant="success">
                      <div> {showSuccessmessage}</div>
                    </Alert>
                  </Card.Body>
                </Card>
              )}
              <br></br>
            </Col>
          </Row>
        </Col>
      </Row>
    </main>
  );
};

export default UpdateTokenRegistration;
